module.exports = __webpack_public_path__ + "static/media/hand.d868bf9c.png";